module.exports = __webpack_public_path__ + "static/apple-touch-icon-b2823e09a731664ab5f09556ced99845.png";